var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.797,
    height: 17.68,
    viewBox: "0 0 21.797 17.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44.9,19.68A12.6,12.6,0,0,0,57.617,6.965V6.359a9.843,9.843,0,0,0,2.18-2.3,10.052,10.052,0,0,1-2.543.727,4.711,4.711,0,0,0,1.938-2.422,11.107,11.107,0,0,1-2.785,1.09A4.325,4.325,0,0,0,53.137,2a4.55,4.55,0,0,0-4.481,4.481,2.361,2.361,0,0,0,.121.969,12.52,12.52,0,0,1-9.2-4.723,4.638,4.638,0,0,0-.605,2.3,4.811,4.811,0,0,0,1.938,3.754,4.082,4.082,0,0,1-2.059-.605h0a4.426,4.426,0,0,0,3.633,4.359,3.733,3.733,0,0,1-1.211.121,2.061,2.061,0,0,1-.848-.121,4.588,4.588,0,0,0,4.238,3.148,9.143,9.143,0,0,1-5.57,1.938A3.353,3.353,0,0,1,38,17.5a11.43,11.43,0,0,0,6.9,2.18",
    transform: "translate(-38 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.031443717d49ffeba58340d16f3eaae1.svg";
export { ForwardRef as ReactComponent };